import React from "react";
import { useSelector } from "react-redux";
import Table from "../../../components/table/coreUiTable/Table";
import { dataForStudioInfoTables } from "../utils/dataForTables";

export const MembershipActivityRevenueTable = () => {
  const tableInfo = useSelector((state) => state.studioInfo.membershipActivityRevenue.tableInfo);
  const currency = useSelector((state) => state.commonReducer.commonProps.currencySymbol);
  return tableInfo.data.length > 0 ? (
    <Table table={tableInfo} {...dataForStudioInfoTables(currency)} />
  ) : (
    <div className="error--medium">No revenue for selected date range</div>
  );
};
